module.exports = __webpack_public_path__ + "img/378.bba5d97d.jpg";